export default "__VITE_ASSET__BD3k7mVo__"